import React from "react";
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


const Footer = () => {

    return (

        <Container fluid>
            <br />
            <br />
            <p style={{textAlign:"center", paddingTop:"20px", borderStyle:"solid none none none", borderColor:"lightGrey"}}>© David Perez</p>
            <br />
        </Container>
    )
}

export default Footer;